import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { IconButton, Tooltip as MuiTooltip } from "@mui/material";

import { TooltipIcon } from "@/assets/icons";

export const StyledTooltip = styled((props) => (
    <MuiTooltip classes={{ popper: props.className, tooltip: "tooltip", arrow: "tooltip-arrow" }} {...props} />
))`
    & .tooltip {
        padding: 4px 8px;
        font-size: var(--size-10);
        line-height: 15px;
        color: var(--color-grey-900);
        text-align: center;
        white-space: pre-line;
        background-color: var(--color-info-light);
    }

    .tooltip-arrow {
        &::before {
            background-color: var(--color-info-light);
        }
    }
`;

type TooltipPlacement =
    | "bottom-end"
    | "bottom-start"
    | "bottom"
    | "left-end"
    | "left-start"
    | "left"
    | "right-end"
    | "right-start"
    | "right"
    | "top-end"
    | "top-start"
    | "top";

type TooltipProps = {
    label: string;
    placement?: TooltipPlacement;
};

const Tooltip: FC<TooltipProps> = ({ label, placement = "bottom-start" }) => {
    const { t } = useTranslation();
    return (
        <StyledTooltip title={t(label)} placement={placement} arrow>
            <IconButton size="large">
                <TooltipIcon />
            </IconButton>
        </StyledTooltip>
    );
};

export default Tooltip;
